import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip } from "recharts";

export const RADAR_COLORS = ["#2A1810", "#C5A059", "#8A3324", "#4F6D4A"];

const AXES = [
  ["appearance_score", "Appearance"],
  ["aroma_score", "Aroma"],
  ["texture_score", "Texture"],
  ["taste_score", "Taste"],
  ["aftertaste_score", "Aftertaste"],
  ["overall_liking_score", "Liking"],
];

export default function SensoryRadar({ series, height = 300, testid = "sensory-radar" }) {
  const usable = series.filter((s) => s.scores && s.scores.count);
  if (!usable.length) {
    return (
      <p className="text-sm text-[#8C7A6B]" data-testid={`${testid}-empty`}>
        No sensory panel results recorded yet — the taste profile appears once an experiment logs panel scores.
      </p>
    );
  }

  const data = AXES.map(([key, name]) => {
    const point = { attribute: name };
    usable.forEach((s) => { point[s.name] = s.scores[key] ?? 0; });
    return point;
  });

  return (
    <div style={{ height }} data-testid={testid}>
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="#E8DFD1" />
          <PolarAngleAxis dataKey="attribute" tick={{ fill: "#5C4A3E", fontSize: 11 }} />
          <PolarRadiusAxis domain={[0, 9]} tick={{ fill: "#8C7A6B", fontSize: 9 }} stroke="#E8DFD1" angle={90} />
          <Tooltip contentStyle={{ background: "#fff", border: "1px solid #E8DFD1", borderRadius: 8, fontSize: 12 }} />
          {usable.length > 1 && <Legend wrapperStyle={{ fontSize: 11, paddingTop: 6 }} />}
          {usable.map((s, i) => (
            <Radar
              key={s.name}
              name={s.name}
              dataKey={s.name}
              stroke={RADAR_COLORS[i % RADAR_COLORS.length]}
              fill={RADAR_COLORS[i % RADAR_COLORS.length]}
              fillOpacity={usable.length > 1 ? 0.14 : 0.25}
              strokeWidth={2}
            />
          ))}
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
